export default "__VITE_ASSET__OOl4BsAX__"